/*
 * The signature on the fake JWT that Login.vue's localhost-only "dev login"
 * mints. It is not signed by anything, so no backend will ever accept it.
 */
export const DEV_TOKEN_SIGNATURE = "dev";

/**
 * Is this the locally-minted dev token rather than a real session?
 *
 * Deliberately narrow: a three-part JWT whose signature segment is exactly
 * `dev`. A real HS256 signature is base64url of 32 bytes, so it can never
 * collide with this.
 */
export const isDevToken = (token) => {
  if (typeof token !== "string") return false;
  const parts = token.split(".");
  return parts.length === 3 && parts[2] === DEV_TOKEN_SIGNATURE;
};

class TokenService {
    getLocalRefreshToken() {
      const user = JSON.parse(localStorage.getItem("user"));
      return user?.refreshToken;
    }
  
    getLocalAccessToken() {
      const user = JSON.parse(localStorage.getItem("user"));
      return user?.access_token;
    }
  
    updateLocalAccessToken(token) {
      let user = JSON.parse(localStorage.getItem("user"));
      user.access_token = token;
      localStorage.setItem("user", JSON.stringify(user));
    }
  
    getUser() {
      return JSON.parse(localStorage.getItem("user"));
    }
  
    setUser(user) {
      console.log(JSON.stringify(user));
      localStorage.setItem("user", JSON.stringify(user));
    }
  
    removeUser() {
      localStorage.removeItem("user");
    }
  }
  
  export default new TokenService();